import {
    Box,
    IconButton,
    TextField,
    Typography,
} from '@mui/material';
import {
    Info,
} from '@mui/icons-material';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { useState, useContext } from 'react';
import { Trans } from 'react-i18next';

import api from '../../api';
import { Context } from '../../context/context';
import { setUser } from '../../context/actions';
import DateFormat from "../../utils/DateFormat";
import DurationPickerDialog from '../shared/DurationPickerDialog';
import FlexTimeConfigPopover from './FlexTimeConfigPopover';

function FlexTimeConfigForm({ detailed = false }) {
    const [{ user }, dispatch] = useContext(Context);
    const [openDurationPicker, setOpenDurationPicker] = useState(false);
    const [popoverAnchorEl, setPopoverAnchorEl] = useState(null);

    const initStartOfFlexTimeAccount = user.startOfFlexTimeAccount ?? new Date();

    const handleCloseDurationPicker = () => {
        setOpenDurationPicker(false);
    };

    const handleDurationSubmit = ({ value }) => {
        const updatedUser = {
            ...user,
            initialFlexTimeAccountBalance: value,
        };
        api.updateUser(user.id, updatedUser).then(() => {
            dispatch(setUser(updatedUser));
        });
    };

    const handleStartdateChange = (value) => {
        const updatedUser = {
            ...user,
            startOfFlexTimeAccount: value,
        };
        api.updateUser(user.id, updatedUser).then(() => {
            dispatch(setUser(updatedUser));
        });
    };

    if (initStartOfFlexTimeAccount !== user.startOfFlexTimeAccount)
        handleStartdateChange(initStartOfFlexTimeAccount)

    const handleOpenPopover = (event) => {
        event.stopPropagation();
        setPopoverAnchorEl(event.currentTarget);
    };

    const handleClosePopover = (event) => {
        event.stopPropagation();
        setPopoverAnchorEl(null);
    };

    return (
        <>
            <Typography>
                {detailed ?
                    <Trans i18nKey='initialBalance' ns='flexTimeConfig'>
                        Bitte gib die initiale Stundenzahl deiner Mehrarbeit bzw. Minusstunden an.
                    </Trans>
                    :
                    <Trans i18nKey='currentBalance' ns='flexTimeConfig'>
                        Bitte gib die aktuelle Stundenzahl deiner Mehrarbeit bzw. Minusstunden an.
                    </Trans>}
            </Typography>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <TextField
                    variant="outlined"
                    sx={{ py: 2 }}
                    value={user.initialFlexTimeAccountBalance !== null ? DateFormat.formatDuration(user.initialFlexTimeAccountBalance) : ''}
                    onClick={() => setOpenDurationPicker(true)}
                />
                {detailed &&
                    <IconButton onClick={handleOpenPopover}>
                        <Info />
                    </IconButton>
                }
            </Box>
            <FlexTimeConfigPopover
                open={Boolean(popoverAnchorEl)}
                anchorEl={popoverAnchorEl}
                onClose={handleClosePopover}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
            />
            <Typography>
                <Trans i18nKey='referenceDate' ns='flexTimeConfig'>
                    Der Stand bezieht sich auf das Arbeitszeitkonto vor (und exklusive) folgendem Datum:
                </Trans>
            </Typography>
            <Box>
                <DatePicker
                    sx={{ py: 2 }}
                    value={initStartOfFlexTimeAccount}
                    onChange={handleStartdateChange}
                />
                <DurationPickerDialog
                    handleSubmit={handleDurationSubmit}
                    value={user.initialFlexTimeAccountBalance ?? 0}
                    open={openDurationPicker}
                    onClose={handleCloseDurationPicker}
                />
            </Box>
        </>
    )

}

export default FlexTimeConfigForm;
